import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/DigitalTools/TrackingSystem/components/SectionApi/SectionApi.module.scss';

const cn = classNames.bind(styles);

const SectionApi = (): ReactElement => {
  return (
    <section className={cn('api')}>
      <div className={cn('container')}>
        <div className={cn('api__title-box')}>
          <h2 className={cn('api__title')}>
            Searates Tracking system API is compatible with any ERP
          </h2>
          <div className={cn('api__title-description')}>
            For additional cost, you can also connect API solution of Tracking to your ERP or other IT systems.
          </div>
        </div>
        <div className={cn('api__image-box')}>
          <img
            className={cn('api__image')}
            src="/images/pages/DigitalTools/TrackingSystem/logos.png"
            alt="Logistic tracking system logos"
          />
        </div>
      </div>


    </section>
  );
};

export default SectionApi;